import { render, staticRenderFns } from "./HonorsV2.vue?vue&type=template&id=9846fa92&scoped=true"
import script from "./HonorsV2.vue?vue&type=script&lang=js"
export * from "./HonorsV2.vue?vue&type=script&lang=js"
import style0 from "./HonorsV2.vue?vue&type=style&index=0&id=9846fa92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9846fa92",
  null
  
)

export default component.exports